import { Form, GroupItem } from "devextreme-react/form";
import { SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { ProductRates } from "./type";


export const NewPriceForm = forwardRef<any, { data: ProductRates }>((
    { data }, ref
) => {

    const localize = useSelector(getLocalized)

    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem colCount={2}>
            <SimpleItem
                dataField={"StartDate"}
                editorType={"dxDateBox"}
                label={{ text: localize.getString("startDate") }}
                editorOptions={{
                    dateSerializationFormat: "yyyy-MM-dd"
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"EndDate"}
                editorType={"dxDateBox"}
                editorOptions={{
                    dateSerializationFormat: "yyyy-MM-dd"
                }}
                label={{ text: localize.getString("endDate") }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"MinimumRent"}
                editorType={"dxNumberBox"}
                label={{ text: localize.getString("minimumRentDay") }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"MaximumRent"}
                editorType={"dxNumberBox"}
                label={{ text: localize.getString("maximumRentDay") }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Price"}
                editorType={"dxNumberBox"}

                label={{ text: localize.getString("price") }}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})